import api from './api';

export interface BookingDto {
  id: string;
  studentId: string;
  teacherId?: string;
  studentName?: string;
  title: string;
  description?: string;
  startTime: string;
  endTime: string;
  studentTimezone?: string;
  teacherTimezone?: string;
  status: 'pending' | 'confirmed' | 'cancelled' | 'completed';
  meetingJoinUrl?: string;
  meetingNumber?: string;
  meetingPassword?: string;
  packageId?: string;
  createdAt: string;
}

export interface CreateBookingRequest {
  title: string;
  description?: string;
  startTime: Date;
  endTime: Date;
}

export const bookingsService = {
  async getBookings(): Promise<BookingDto[]> {
    const response = await api.get<BookingDto[]>('/bookings');
    return response.data;
  },

  async getBooking(id: string): Promise<BookingDto> {
    const response = await api.get<BookingDto>(`/bookings/${id}`);
    return response.data;
  },

  async createBooking(booking: CreateBookingRequest): Promise<BookingDto> {
    const response = await api.post<BookingDto>('/bookings', {
      ...booking,
      startTime: booking.startTime.toISOString(),
      endTime: booking.endTime.toISOString(),
    });
    return response.data;
  },

  async updateBookingStatus(
    id: string,
    status: string,
    meeting?: { meetingJoinUrl?: string; meetingNumber?: string; meetingPassword?: string }
  ): Promise<BookingDto> {
    const response = await api.put<BookingDto>(`/bookings/${id}/status`, {
      status,
      ...meeting,
    });
    return response.data;
  },

  async cancelBooking(id: string): Promise<void> {
    await api.delete(`/bookings/${id}`);
  },
};


